var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimesCircleSolid = function SvgTimesCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.6C8.2 1.6 1.6 8.2 1.6 16S8 30.4 16 30.4c7.8 0 14.4-6.4 14.4-14.4S23.8 1.6 16 1.6m6.4 18c.8.8.8 2 0 2.8s-2 .8-2.8 0L16 18.8l-3.6 3.6c-.8.8-2 .8-2.8 0s-.8-2 0-2.8l3.6-3.6-3.6-3.6c-.8-.8-.8-2 0-2.8s2-.8 2.8 0l3.6 3.6 3.6-3.6c.8-.8 2-.8 2.8 0s.8 2 0 2.8L18.8 16z"
  })));
};
export default SvgTimesCircleSolid;